export const Product = {
  Comfort_Daily_Spheric: "comfort_daily_spheric",
  Comfort_Monthly_Spheric: "comfort_monthly_spheric",
  Platinum_Daily_Spheric: "platinum_daily_spheric",
  Platinum_Daily_Toric: "platinum_daily_toric",
  Premium_Daily_Spheric: "premium_daily_spheric",
  Premium_Monthly_Multifocal: "premium_monthly_multifocal",
  Premium_Monthly_Spheric: "premium_monthly_spheric",
  Premium_Monthly_Toric: "premium_monthly_toric",
  Sehtest_oder_Anpassung: "sehtest_oder_anpassung",
};

export const State = {
  START: "start",
  L1_1: "kennen_sie_ihre_sehschwaeche",
  L1_2: "tragen_sie_ein_bestimmtes_kontaklinsen_produkt",
  L2_1: "welche_art_von_sehschwaeche_wollen_sie_korrigieren",
  L2_2: "tragen_sie_monats_oder_tageslinsen",
  L2_3: "daily_dropdown",
  L2_4: "monthly_dropdown",
  L3_1:
    "wie_oft_wollen_sie_ihre_kontaktlinse_tragen_from_kurz_oder_weitsichtigkeit",
  L3_2: "wie_oft_wollen_sie_ihre_kontaktlinse_tragen_from_hornhautverkruemmung",
  L4_1: "möchten_sie_auch_nachts_ihre_cl_tragen",
  L4_2: "haben_sie_trockene_oder_empfindliche_augen",
  L5_1: "wollen_sie_ihre_cl_laenger_als_8_stunden_am_tag_tragen",
};

export const Trigger = {
  NEUSTARTEN: "neustarten",
  ERSTTRAEGER: "ersttraeger_kontaktlinse",
  NEUTRAEGER: "neutraeger_truelens",
  TAGESLINSEN: "tageslinsen",
  MONATSLINSEN: "monatslinsen",
  JA: "ja",
  NEIN: "nein",
  DAUERND: "dauernd",
  GELEGENTLICH: "gelegentlich",
  KURZ_ODER_WEIT: "kurz_oder_weitsichtigkeit",
  HORNHAUT: "hornhautverkruemmung",
  ALTERSSICHTIGKEIT: "alterssichtigkeit",
  LINSE_NICHT_ENTHALTEN: "linse_nicht_enthalten",
};

export const Action = {};



// WEBPACK FOOTER //
// ./src/Wizard/IDs.js